'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPath$0024$0024anon$0024126 from "./presto.types$-Path$$anon$126.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Path$() {
  this.c89 = null;
  this.c8a = false;
  this.c87 = null;
  this.c88 = false;
  this.c8b = null;
  this.c8c = false;
}
export { $c_Lpresto_types$Path$ as $c_Lpresto_types$Path$ };
$p = $c_Lpresto_types$Path$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Path$;
/** @constructor */
function $h_Lpresto_types$Path$() {
}
export { $h_Lpresto_types$Path$ as $h_Lpresto_types$Path$ };
$h_Lpresto_types$Path$.prototype = $p;
$p.cI8 = (function() {
  if ((!this.c8a)) {
    this.c89 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c8a = true;
  }
  return this.c89;
});
$p.iK = (function() {
  if ((!this.c88)) {
    this.c87 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c88 = true;
  }
  return this.c87;
});
$p.cJ4 = (function() {
  if ((!this.c8c)) {
    this.c8b = new $j_presto$002etypes$0024$002dPath$0024$0024anon$0024126.$c_Lpresto_types$Path$$anon$126(this);
    this.c8c = true;
  }
  return this.c8b;
});
var $d_Lpresto_types$Path$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Path$, "presto.types$Path$", ({
  a0G: 1,
  D: 1
}));
export { $d_Lpresto_types$Path$ as $d_Lpresto_types$Path$ };
var $n_Lpresto_types$Path$;
function $m_Lpresto_types$Path$() {
  if ((!$n_Lpresto_types$Path$)) {
    $n_Lpresto_types$Path$ = new $c_Lpresto_types$Path$();
  }
  return $n_Lpresto_types$Path$;
}
export { $m_Lpresto_types$Path$ as $m_Lpresto_types$Path$ };
//# sourceMappingURL=presto.types$-Path$.js.map
